module.exports = __webpack_public_path__ + "static/media/menu_icon_homevisit_hover.650a3c53.png";